import { addHours, format, type Locale, parseISO } from "date-fns";
import { enUS, id } from "date-fns/locale";
import i18next from "i18next";

const localeMap: Record<string, Locale> = {
  id,
  en: enUS
};

export const getLocalOffsetTimeZone = () => {
  return new Date().getTimezoneOffset() / -60;
};

export const adjustForUTCOffset = (date: Date) => {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
};

export const addHoursBaseOnOffset = (date: Date) => {
  switch (getLocalOffsetTimeZone()) {
    case 8:
      return addHours(date, 1);
    case 9:
      return addHours(date, 2);
    default:
      return addHours(date, 0);
  }
};

export const formatTime = (time: string, status = "expire") => {
  const lang = i18next.language ?? "en";
  const parsedDate = parseISO(time);
  const dateWithOffset = adjustForUTCOffset(parsedDate);
  let formatString;

  if (status === "expire") {
    formatString = "EEEE, dd MMMM yyyy HH:mm";
  } else {
    formatString = "EEEE, dd MMMM yyyy";
  }

  return format(addHoursBaseOnOffset(dateWithOffset), formatString, {
    locale: localeMap[lang] ?? enUS
  });
};

export const formatWithLocale = (
  date: string | number | Date,
  formatString: string
) => {
  const lang = i18next.language ?? "en";

  return format(date, formatString, {
    locale: localeMap[lang] ?? enUS
  });
};

export const formatWithOffset = (date: string, formatString: string) => {
  const parsedDate = parseISO(date);
  const dateWithOffset = adjustForUTCOffset(parsedDate);

  return format(addHoursBaseOnOffset(dateWithOffset), formatString, {
    locale: localeMap[i18next.language ?? "en"] ?? enUS
  });
};
